module.exports = __webpack_public_path__ + "static/media/58 - Donna Summer - Spring Affair.38b52bf6.mp3";